var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#FF7A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.333 15.6001L23.5878 10.711C23.4182 10.6253 23.231 10.5805 23.0411 10.5801C22.8511 10.5797 22.6637 10.6236 22.4938 10.7085L12.6825 15.5977C12.3195 15.781 12.0689 16.1318 12.0176 16.5351C12.0017 16.6537 10.6181 28.4414 22.4571 34.8792C22.6391 34.9785 22.8435 35.0296 23.0508 35.0276C23.2581 35.0257 23.4614 34.9708 23.6415 34.8682C35.0173 28.4402 34.0481 17.0558 34.0016 16.5743C33.9816 16.3686 33.9098 16.1714 33.7929 16.001C33.6759 15.8307 33.5177 15.6927 33.333 15.6001Z",
    fill: "#FF7A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5451 14.2598H23.9481V19.979L23.6357 26.2496H21.8575L21.5451 19.979V14.2598ZM21.1606 29.7408C21.1606 29.2662 21.2968 28.891 21.5692 28.6154C21.8575 28.3397 22.258 28.2019 22.7706 28.2019C23.1872 28.2019 23.5556 28.3551 23.876 28.6613C24.2124 28.9676 24.3806 29.3274 24.3806 29.7408C24.3806 30.2002 24.2285 30.5754 23.9241 30.8663C23.6197 31.142 23.2352 31.2798 22.7706 31.2798C22.3381 31.2798 21.9616 31.1266 21.6412 30.8204C21.3208 30.5141 21.1606 30.1543 21.1606 29.7408Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.018ffc82e057f3f7b955df702f49d42c.svg";
export { ForwardRef as ReactComponent };